export default __webpack_public_path__ + "static/media/icon1.cddf1840.svg";